import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  // We use a Signal with a Map to track multiple loader IDs
  private loaders = signal<Map<string, boolean>>(new Map());

  show(id: string = 'global') {
    this.loaders.update((map) => new Map(map.set(id, true)));
  }

  hide(id: string = 'global') {
    this.loaders.update((map) => {
      const newMap = new Map(map);
      newMap.delete(id);
      return newMap;
    });
  }

  // Check if a specific loader is active
  isLoading(id: string = 'global'): boolean {
    return !!this.loaders().get(id);
  }
}
